document.addEventListener('DOMContentLoaded', function () {
    const stepBlocks = document.querySelectorAll('.quiz-main-blocks');
    const backBtn = document.querySelector('.block__questionaire-quiz-back-btn a');
    let activeTimer = null;


    function goToStep(targetId,data_ans) {
        const targetStep = document.querySelector(targetId);
        if (!targetStep) return;

        if (activeTimer) {
        clearTimeout(activeTimer);
        activeTimer = null;
        }

        stepBlocks.forEach(step => step.classList.remove('active'));

        targetStep.classList.add('active');

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        if(data_ans) {
            document.querySelectorAll('[data-prev-step-ans]').forEach(block => {
                const blockAns = block.getAttribute('data-prev-step-ans');
                if (blockAns === data_ans) {
                  block.style.display = 'block';
                } else {
                  block.style.display = 'none';
                }
            });
        }

        if (targetStep.dataset.autoNext === 'true') {
            const delay = parseInt(targetStep.dataset.delay, 10) || 5000;

            const currentIndex = Array.from(stepBlocks).indexOf(targetStep);
            const nextStep = stepBlocks[currentIndex + 1];

            if (nextStep) {
                activeTimer = setTimeout(function () {
                goToStep(`#${nextStep.id}`);
                }, delay);
            }
        }
        const currentIndex = Array.from(stepBlocks).findIndex(step =>
            step.classList.contains('active')
        );
        if (currentIndex <= 0) return;
        const prevStep = stepBlocks[currentIndex - 1];
        const prevHref = `#${prevStep.id}`;
        backBtn.setAttribute('href', prevHref);
    }

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.answer-clickable-btn, .continue-clickable-btn');
        if (!btn) return;

        const href = btn.getAttribute('href');
        if (!href || !href.startsWith('#step--')) return;
        var data_ans = e.target.getAttribute('data-ans');
        e.preventDefault();
        goToStep(href,data_ans);
    });

    if (backBtn) {
        backBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const prevHref = e.currentTarget.getAttribute('href');

            if (!prevHref || !prevHref.startsWith('#step--')) return;

            goToStep(prevHref);
            setTimeout(() => {
                const currentIndex = Array.from(stepBlocks).findIndex(step =>
                    step.classList.contains('active')
                );
                
                if(currentIndex == 0){
                    backBtn.setAttribute('href', '#');
                } else if (currentIndex <= 0) return;
                const prevStep = stepBlocks[currentIndex - 1];
                const prevHref2 = `#${prevStep.id}`;
                backBtn.setAttribute('href', prevHref2);
            }, 500);
        });
    }


    const texts = [];
    let i = 1;
    while (document.querySelector('.block_quiz_type_4-change-text').dataset[`text${i}`]) {
        texts.push(document.querySelector('.block_quiz_type_4-change-text').dataset[`text${i}`]);
        i++;
    }
    let index = 0;
    const msg = document.querySelector('.block_quiz_type_4-change-text p');

    function show(){
        msg.classList.remove("active");
        setTimeout(()=>{
        msg.textContent = texts[index];
        msg.classList.add("active");
        index = (index+1) % texts.length;
        },60);
    }
    show();
    const intervalID = setInterval(show,2000);
});